import { NotOnTargetCtrl } from './not-on-target.controller';

export const NotOnTarget = {
  controller: NotOnTargetCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./not-on-target.html'),
};
